export interface IServerErrorItem {
  code: string;
  key: string;
  message: string;
}

export interface IServerError {
  /* oxlint-disable-next-line typescript/no-explicit-any */
  errors: (any | IServerErrorItem)[];
  message: string;
  statusCode?: number;
}

export function isResponseContainsKey<S extends object, E>(response: S | E, key: string): response is S {
  return key in (response as S);
}
